var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"PageHeader"}},[_c('header',[_c('navbar',{attrs:{"isNormally":_vm.isNormally}}),(!_vm.isNormally)?_c('banner'):_c('div',{staticClass:"navbar-placeholder-for-fixed"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }